module.exports = __webpack_public_path__ + "media/application/images/2023/03_still-1600x900-3fef3ac3735383efac33fc47d01e4d18.png";